// extracted by mini-css-extract-plugin
export default {"root":"MediaCard_root__wECDJ","titleWrapper":"MediaCard_titleWrapper__IPY1J","title":"MediaCard_title__4y74D"};